module.exports = __webpack_public_path__ + "media/images/lp/lp05-cb34f04902d85dbecaacb868d7c0439f.webp";